<template>
  <ul>
    <li class="wavveon-list-item">
      <WavveonLive></WavveonLive>
      <span class="wavveon-list-txt">
        <span>국내 유일 지상파 실시간 방송</span>
        <span>KBS, SBS, MBC 등 지상파와 종편부터 해외 시리즈, 애니, 라디오까지 80여개 채널 제공</span>
      </span>
    </li>
    <li class="wavveon-list-item">
      <WavveonVod></WavveonVod>
      <span class="wavveon-list-txt">
        <span>프리미엄 VOD 서비스</span>
        <span>국내·외 드라마, 예능 등 인기 프로그램과 애니, 키즈까지 포함한 20만편의 방송 VOD 제공</span>
      </span>
    </li>
    <li class="wavveon-list-item">
      <WavveonMovie></WavveonMovie>
      <span class="wavveon-list-txt">
        <span>영화 서비스</span>
        <span>웨이브온에서만 무료로 볼 수 있는 매주 업데이트되는 최신 인기 Wavvie 영화</span>
      </span>
    </li>
    <li class="wavveon-list-item">
      <WavveonMarketing></WavveonMarketing>
      <span class="wavveon-list-txt">
        <span>사업장 매출 증대</span>
        <span>사업장 내 Wavve 서비스 제공으로 고객의 매장 재방문 유도 및 매출 증대 기여</span>
      </span>
    </li>
  </ul>
</template>

<script>
import WavveonLive from '@/assets/svg/common/ic-my-wavveon-live.svg'
import WavveonVod from '@/assets/svg/common/ic-my-wavveon-vod.svg'
import WavveonMovie from '@/assets/svg/common/ic-my-wavveon-movie.svg'
import WavveonMarketing from '@/assets/svg/common/ic-my-wavveon-marketing.svg'
export default {
  name: 'WavveOnIntroduce',
  components: {
    WavveonLive,
    WavveonVod,
    WavveonMovie,
    WavveonMarketing
  }
}
</script>
